import { createContext } from 'react';
const setUpdateLastDayDetails = (prev, update) => {
    const newData = update.bucketedData;
    if (newData !== null) {
        newData.forEach((val) => {
            const id = val.id.toUpperCase();
            const existing = prev.gateways[id];
            const formatted = val;
            if (existing) {
                prev.gateways[id] = {
                    ...existing,
                    bucketed: { ...existing.bucketed, ...formatted },
                    combined: { ...existing.combined, ...formatted },
                };
            }
            else {
                prev.gateways[id] = { bucketed: val, combined: val, database: null, wireless: null };
            }
        });
    }
    prev = { ...prev, queries: { ...prev.queries, setUpdateLastDayDetails: newData !== null } };
    return prev;
};
const setUpdateWirelessStatistics = (prev, update) => {
    const newData = update.networksData;
    if (newData !== null) {
        newData.forEach((val) => {
            const id = val.LoRaWAN?.GatewayEui?.toUpperCase();
            const formatted = {
                ...val.LoRaWAN,
                ConnectionStatus: val.ConnectionStatus,
                LastUplinkReceivedAt: val.LastUplinkReceivedAt,
                id: id,
                name: val.Name,
            };
            if (id) {
                const existing = prev.gateways[id];
                if (existing) {
                    prev.gateways[id] = {
                        ...existing,
                        wireless: { ...existing.wireless, ...formatted },
                        combined: { ...existing.combined, ...formatted },
                    };
                }
                else {
                    prev.gateways[id] = { wireless: formatted, combined: formatted, database: null, bucketed: null };
                }
            }
        });
    }
    prev = { ...prev, queries: { ...prev.queries, setUpdateWirelessStatistics: newData !== null } };
    return prev;
};
const setUpdateDatabaseDetails = (prev, update) => {
    const newData = update.gatewayData;
    if (newData !== null) {
        newData.forEach((val) => {
            const id = val.id.toUpperCase();
            const existing = prev.gateways[id];
            const formatted = val;
            if (existing) {
                prev.gateways[id] = {
                    ...existing,
                    database: { ...existing.database, ...formatted },
                    combined: { ...existing.combined, ...formatted },
                };
            }
            else {
                prev.gateways[id] = { database: val, combined: val, wireless: null, bucketed: null };
            }
        });
    }
    prev = { ...prev, queries: { ...prev.queries, setUpdateDatabaseDetails: newData !== null } };
    return prev;
};
export const gatewayListReducer = (prev, action) => {
    switch (action.type) {
        case 'setUpdateLastDayDetails':
            return setUpdateLastDayDetails(prev, action);
        case 'setUpdateWirelessStatistics':
            return setUpdateWirelessStatistics(prev, action);
        case 'setUpdateDatabaseDetails':
            return setUpdateDatabaseDetails(prev, action);
    }
};
export const defaultState = {
    queries: { setUpdateLastDayDetails: false, setUpdateDatabaseDetails: false, setUpdateWirelessStatistics: false },
    gateways: {},
};
export const AWSGatewaysContext = createContext({
    state: defaultState,
    dispatch: () => {
        throw new Error('AWSGatewaysContext dispatch function not initialized!');
    },
});
